<script setup>
import ApikomTaskTable from '@frontJs/components/tables/projectManagement/tasks/ApikomTaskTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { useRoute } from '@js/utils/route';
import { h, onMounted, ref } from 'vue';

const { route } = useRoute();

const loading = ref(true);

const data = ref({
    projects: 0,
    devToTake: 0,
    devOngoing: 0,
    devClosed: 0,
    otherProjects: 0,
    closedProjects: 0,
});

function updateData() {
    loading.value = true;

    Promise.all([
        axios.post(route('front.projectManagement.task.postTaskCount'), {
            status: ['open', 'to_process'],
            type: 'project',
            noOneResponsible: false,
        }),
        axios.post(route('front.projectManagement.task.postTaskCount'), {
            status: ['open', 'to_process'],
            type: 'project',
            theme: 'dev',
            noOneResponsible: true,
        }),
        axios.post(route('front.projectManagement.task.postTaskCount'), {
            status: ['open', 'to_process'],
            type: 'project',
            theme: 'dev',
            noOneResponsible: false,
        }),
        axios.post(route('front.projectManagement.task.postTaskCount'), {
            status: 'closed',
            type: 'project',
            theme: 'dev',
        }),
        axios.post(route('front.projectManagement.task.postTaskCount'), {
            status: ['open', 'to_process'],
            type: 'project',
            theme: ['seo', 'sea', 'smo', 'sma', 'sem', 'cs'],
        }),
        axios.post(route('front.projectManagement.task.postTaskCount'), {
            status: 'closed',
            type: 'project',
        }),
    ])
        .then(
            ([
                projectsData,
                devToTakeData,
                devOngoingData,
                devClosedData,
                otherProjectsData,
                closedProjectsData,
            ]) => {
                data.value.projects = projectsData.data.count;
                data.value.devToTake = devToTakeData.data.count;
                data.value.devOngoing = devOngoingData.data.count;
                data.value.devClosed = devClosedData.data.count;
                data.value.otherProjects = otherProjectsData.data.count;
                data.value.closedProjects = closedProjectsData.data.count;
            },
        )
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            loading.value = false;
        });
}

onMounted(() => {
    updateData();
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Projets Apikom - Tâches - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - Tâches - Projets Apikom </PageTitle>

    <TabLayout
        :tabs="{
            projects: {
                title: 'Projets',
                total: data.projects,
                content: h(ApikomTaskTable, {
                    userSessionKey: 'projects_dev',
                    type: 'project',
                    status: ['open', 'to_process'],
                    noOneResponsible: false,
                    createTaskUrl: route(
                        'front.projectManagement.task.createTask',
                        {
                            type: 'project',
                        },
                    ),
                }),
            },
            devToTake: {
                title: 'DEV à prendre',
                total: data.devToTake,
                content: h(ApikomTaskTable, {
                    userSessionKey: 'projects_dev_to_take',
                    type: 'project',
                    theme: 'dev',
                    status: ['open', 'to_process'],
                    noOneResponsible: true,
                    createTaskUrl: route(
                        'front.projectManagement.task.createTask',
                        {
                            type: 'project',
                            theme: 'dev',
                            noOneResponsible: true,
                        },
                    ),
                }),
            },
            devOngoing: {
                title: 'DEV en cours',
                total: data.devOngoing,
                content: h(ApikomTaskTable, {
                    userSessionKey: 'projects_dev_ongoing',
                    type: 'project',
                    theme: 'dev',
                    status: ['open', 'to_process'],
                    noOneResponsible: false,
                    createTaskUrl: route(
                        'front.projectManagement.task.createTask',
                        {
                            type: 'project',
                            theme: 'dev',
                        },
                    ),
                }),
            },
            devClosed: {
                title: 'DEV fermés',
                total: data.devClosed,
                content: h(ApikomTaskTable, {
                    userSessionKey: 'projects_dev_closed',
                    type: 'project',
                    theme: 'dev',
                    status: 'closed',
                    createTaskUrl: route(
                        'front.projectManagement.task.createTask',
                        {
                            type: 'project',
                            theme: 'dev',
                        },
                    ),
                }),
            },
            otherProjects: {
                title: 'Autres',
                total: data.otherProjects,
                content: h(ApikomTaskTable, {
                    userSessionKey: 'projects_other',
                    type: 'project',
                    theme: ['seo', 'sea', 'smo', 'sma', 'sem', 'cs'],
                    status: ['open', 'to_process'],
                    createTaskUrl: route(
                        'front.projectManagement.task.createTask',
                        {
                            type: 'project',
                        },
                    ),
                }),
            },
            closedProjects: {
                title: 'Fermés',
                total: data.closedProjects,
                content: h(ApikomTaskTable, {
                    userSessionKey: 'projects_closed',
                    type: 'project',
                    status: 'closed',
                    createTaskUrl: route(
                        'front.projectManagement.task.createTask',
                        {
                            type: 'project',
                        },
                    ),
                }),
            },
        }"
        :loading="loading"
    />
</template>
